import { shallowMount } from '@vue/test-utils';

import Component from './ItemsModal.vue';
import { ORDER_ITEM, ORDER_WITH_ITEMS } from '../../../../../libs/shared/fixtures/orders.fixtures';

const items = [ORDER_ITEM];
const order = ORDER_WITH_ITEMS;

let wrapper;

describe('ItemsModal', () => {
  beforeEach(() => {
    wrapper = shallowMount(Component, {
      props: {
        items,
        order,
      },
    });
  });

  test('render', () => {
    expect(wrapper.isVisible()).toBe(true);
  });
});
